import { create } from 'zustand';

import { SignatureFormType } from '../enums/signature-form-type.const';

type SignatureFormStoreState = {
  closeForm: () => void;
  currentStep: number;
  isOpen: boolean;
  openForm: (type: SignatureFormType) => void;
  reset: () => void;
  setStep: (step: number) => void;
  totalSteps: number;
  type: SignatureFormType;
};

const INITIAL_STATE: Omit<SignatureFormStoreState, 'closeForm' | 'openForm' | 'reset' | 'setStep'> =
  {
    currentStep: 1,
    isOpen: false,
    totalSteps: 5,
    type: SignatureFormType.QUICK_SIGN,
  };

export const SignatureFormStore = create<SignatureFormStoreState>()((set) => ({
  ...INITIAL_STATE,

  closeForm: () => set(INITIAL_STATE),

  openForm: (type) => {
    set({ ...INITIAL_STATE, type, isOpen: true });
  },

  reset: () => set(INITIAL_STATE),

  setStep: (step) => set({ currentStep: step }),
}));
